export default "__VITE_ASSET__lhdxnsAT__"